import { Base, withFreezedOptions } from "@studiometa/js-toolkit";
import { map, clamp, animate } from "@studiometa/js-toolkit/utils";
class AbstractScrollAnimation extends withFreezedOptions(Base) {
  /**
   * Config.
   */
  static config = {
    name: "AbstractScrollAnimation",
    options: {
      playRange: {
        type: Array,
        default: () => [0, 1]
      },
      from: {
        type: Object,
        default: () => ({})
      },
      to: {
        type: Object,
        default: () => ({})
      },
      keyframes: {
        type: Array
      },
      easing: {
        type: Array,
        default: () => [0, 0, 1, 1]
      }
    }
  };
  /**
   * Get the target element for the animation.
   */
  get target() {
    return this.$el;
  }
  /**
   * Lazily get animation.
   */
  get animation() {
    let { keyframes } = this.$options;
    const { from, to } = this.$options;
    if (keyframes.length <= 0 && from && to) {
      keyframes = [from, to];
    }
    const animation = animate(this.target, keyframes, { easing: this.$options.easing });
    Object.defineProperty(this, "animation", {
      value: animation,
      configurable: true
    });
    return animation;
  }
  scrolledInView(props) {
    const progress = map(
      clamp(props.dampedProgress.y, this.$options.playRange[0], this.$options.playRange[1]),
      this.$options.playRange[0],
      this.$options.playRange[1],
      0,
      1
    );
    this.render(progress);
  }
  /**
   * Render the animation for the given progress.
   */
  render(progress) {
    this.animation.progress(progress);
  }
}
export {
  AbstractScrollAnimation
};
//# sourceMappingURL=AbstractScrollAnimation.js.map
